// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"342":"c50c4c07","545":"5411ab6c"}[chunkId] + ".chunk.js";
};